import React from "react";

export default function Loading({ message, isSaving }) {
  return (
    <div style={{ marginTop: 10, marginBottom: 10 }}>
      {message ? message : isSaving ? "Saving data..." : "Loading data..."}
    </div>
  );
}
